'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Notification } from 'base-ui'

export type FormSubmissionStatus = 'error' | 'success' | false

type Props = {
  dataQaId?: string
  formSubmissionStatus: FormSubmissionStatus
}
export const MediServiceFormSubmissionNotification: FC<Props> = ({
  dataQaId,
  formSubmissionStatus,
}) => {
  if (formSubmissionStatus === 'success') {
    return (
      <Notification
        className="self-stretch"
        data-qa-id={dataQaId}
        severity={formSubmissionStatus}
      >
        <FormattedMessage id="chrx.questionnaire.notifications.questionnaire-submitted-successfully" />
      </Notification>
    )
  }

  if (formSubmissionStatus === 'error') {
    return (
      <Notification
        className="self-stretch"
        data-qa-id={dataQaId}
        severity={formSubmissionStatus}
      >
        <FormattedMessage id="chrx.messsages.general-error" />
      </Notification>
    )
  }

  return null
}
